var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMySavillsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#252839",
    fillRule: "nonzero",
    d: "M0 0h71v71H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.613 66.456c-2.415 0-4.053-1.233-4.053-3.522v-.088h1.326v.058c0 1.497 1.09 2.378 2.738 2.378.884 0 2.563-.381 2.563-1.79 0-2.73-6.303-.793-6.303-4.697 0-1.966 1.838-2.847 3.664-2.847 2.15 0 3.611 1.232 3.611 3.229v.088h-1.325v-.088c0-1.292-.913-2.055-2.386-2.055-1.031 0-2.239.44-2.239 1.615 0 2.553 6.303.762 6.303 4.696 0 2.083-1.956 3.023-3.899 3.023m12.845-.293c-.116-.294-.198-1.292-.198-1.761V59c0-2.143-1.302-3.053-3.568-3.053-2.091 0-3.921.94-3.921 3.258v.088h1.307v-.088c0-1.497 1.104-2.083 2.47-2.083 1.626 0 2.38.586 2.38 1.907 0 1.027-.492 1.145-1.423 1.262l-.493.06c-2.295.263-4.648.527-4.648 3.169 0 1.82 1.22 2.935 3.254 2.935 1.772 0 2.904-.792 3.398-1.879 0 0 0 1.057.145 1.586h1.297Zm-1.42-3.79c0 .758-.26 1.459-.755 1.984-.609.613-1.48.963-2.467.963-.958 0-2.032-.525-2.032-1.78 0-1.517 1.625-1.867 3.367-2.072l.929-.116c.262-.03.755-.117.958-.292v1.313Zm10.082-6.141h-1.415l-2.7 8.423-2.73-8.423h-1.533l3.528 9.94h1.44l3.41-9.94Zm2.13-2.469c0-.532-.43-.939-.923-.939-.492 0-.923.407-.923.908 0 .532.43.938.923.938a.933.933 0 0 0 .923-.938v.031Zm-.142 12.409v-9.94H51.688v9.94h1.42Zm2.698 0V52.54H54.386v13.632h1.42Zm2.698 0V52.54H57.084v13.632h1.42Zm4.777.284c1.938 0 3.885-.94 3.885-3.023 0-3.934-6.308-2.143-6.308-4.696 0-1.175 1.203-1.615 2.258-1.615 1.468 0 2.378.763 2.378 2.055v.088h1.32v-.088c0-1.997-1.456-3.229-3.626-3.229-1.82 0-3.65.88-3.65 2.847 0 3.904 6.307 1.967 6.307 4.696 0 1.41-1.701 1.791-2.58 1.791-1.615 0-2.73-.88-2.73-2.378v-.058h-1.321v.088c0 2.29 1.632 3.522 4.067 3.522",
    fill: "#FFDF00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica-Light, Helvetica",
    fontSize: 18.93,
    fontWeight: 300,
    letterSpacing: -1.278,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.13,
    y: 66.712
  }, "my")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySavillsLogo);
export default __webpack_public_path__ + "static/media/mySavillsLogo.c18072c03aa67e91e143797c49f420c1.svg";
export { ForwardRef as ReactComponent };